import React, {  } from "react"
import { ParametrosDaSessaoARContext } from ".";
import { EnumTipoUsuario } from "../../../../Models/Domain/AreaRestrita/Sessao";

export type ParametrosDaSessaoDoAluno = {
    tipoDeUsuario: EnumTipoUsuario.Aluno,
}

export const ComParametrosDaSessaoDoAluno: React.FC<{
    children: React.ReactNode
}> = (props) => {

    const parametros: ParametrosDaSessaoDoAluno = {
        tipoDeUsuario: EnumTipoUsuario.Aluno
    };

    return <React.Fragment>
        <ParametrosDaSessaoARContext.Provider value={parametros}>
            {props.children}
        </ParametrosDaSessaoARContext.Provider>
    </React.Fragment>
}